<header class="header">
  <a class="logo" [routerLink]="['/']"></a>
  <button *ngIf="expanded" @fadeInOnEnter (click)="menu.collapse()" mat-ripple class="collapse-btn">
    Collapse Menu
    <mat-icon>chevron_left</mat-icon>
  </button>
</header>

<button mat-fab class="fab-like" *ngIf="!expanded" (click)="menu.expand()">
  <mat-icon>chevron_right</mat-icon>
</button>

<community-nav role="navigation" aria-label="Main navigation">
 
</community-nav>
 
<div class="spacer"></div>

<community-nav [pinned]="true" role="navigation" aria-label="Bottom navigation"></community-nav>
<a class="sidebar-link" target="_blank" href="https://recyclingpartnership.org/terms-and-conditions-circular-packaging-assessment-recycling-program-solutions-hub-and-policy-readiness-knowledge-hub/" style="font-size: 0.8rem;text-decoration: underline;text-align: right;width: calc(100% - 2rem);">Terms &amp; Conditions
</a>
<div class="user">
  <trp-user-info *ngIf="userLoaded$ | async; else loading"></trp-user-info>
  <ng-template #loading>
    <div class="loading"></div>
  </ng-template>
</div>
